import React, { Component, Fragment } from 'react';
import { FormControl, Modal, Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { updateUserRole } from '../../redux/actions/user';

class ChangeRoleSelect extends Component<any, any> {
  constructor(props: any, context: any) {
    super(props, context);
    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);

    this.state = {
      selectedRole: {},
    };
  }

  handleClose() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  _changeSelectedRole = () => {
    this.props.updateUserRole(this.state.selectedRole);
    this.handleClose();
  };

  _setCurrentRole = (event: any) => {
    this.handleShow();
    this.setState({
      selectedRole: this.props.roles[event.target.value],
    });
  };

  _checkCurrentRole = (roleId: any) => {
    if (roleId === this.props.currentRole.userRoleId) {
      return roleId;
    } 
    // else {
    //   return false;
    // }
    return
  };

  render() {
    return (
      <Fragment>
        <FormControl as='select' className='mr-sm-2' onChange={(e) => this._setCurrentRole(e)}>
          {this.props.roles.map((role: any, index: any) => {
            return (
            <option key={index} value={index} selected={this._checkCurrentRole(role.userRoleId)}>
              {role.roleName} ({role.departmentAbbreviation})
            </option>
          )})}
        </FormControl>

        <Modal show={this.state.show} onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Change role?</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure you want to change your role?</Modal.Body>
          <Modal.Footer>
            <Button variant='secondary' onClick={this.handleClose}>
              No
            </Button>
            <Button variant='primary' onClick={this._changeSelectedRole}>
              Yes
            </Button>
          </Modal.Footer>
        </Modal>
      </Fragment>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    roles: state.user.roles,
    currentRole: state.user.currentRole,
  };
};

export default connect(mapStateToProps, { updateUserRole })(ChangeRoleSelect);
